import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";
import { MovFormaPagamento } from "../../../../Models/Financeiro/Conta/Movimentacao/MovFormaPagamento";
import RequestUtilitario, { QueryBasicaParam } from "../../../../Utils/RequisicaoUtilitario";
import { AxiosResponse } from "axios";

export function useMovFormaPagamentoListar({
    movFormaPagamento,
    ativo
}:QueryBasicaParam<AxiosResponse<MovFormaPagamento[]>, MovFormaPagamento[], {
    movFormaPagamento?:MovFormaPagamento,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(movFormaPagamento ?? {}),
        ativo
    });

    return useQuery({
        queryKey : ["Financeiro", "Conta", "Movimentacao", "MovFormaPagamento", "Listar", queryString ],
        queryFn : () => Axios.get<MovFormaPagamento[]>(`financeiro/conta/movimentacao/movFormaPagamento?${queryString}`),
        staleTime : 1000 * 60 * 2.5,
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                return m;
            });
        },
    });
}